module.exports = __webpack_public_path__ + "img/Slideshow-flow-video-auto.9702a923.png";